module.exports = __webpack_public_path__ + "static/img/291_TO8_2469.942109c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/291_TO8_2469.jpg
// module id = uceq
// module chunks = 0